module.exports = __webpack_public_path__ + "static/03-8040f137457e61b60a0c598491a90208.jpg";